import gardenListSaga from 'modules/Garden/saga/list';
import gardenDetailsSaga from 'modules/Garden/saga/details';
import { SagaIterator } from 'redux-saga';
import { fork } from 'redux-saga/effects';

export default function* gardenSaga(): SagaIterator {
  yield fork(gardenListSaga);
  yield fork(gardenDetailsSaga);
}
